'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Pencil = require('./Pencil');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Pencil).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Pencil/index.js
// module id = 1250
// module chunks = 1